export function adjustSliderBreakpoints(): number {
    const isBrowserSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    return isBrowserSafari ? document.documentElement.clientWidth - window.innerWidth : 0;
}
